import { theme as baseTheme } from '../aidu/index.js';
import { colors } from '../invia/colors.js';
import { typography } from '../invia/typography.js';
export const theme = {
  ...baseTheme,
  typography,
  fontFamily: 'Roboto, sans-serif',
  colors
};